module.exports = __webpack_public_path__ + "static/media/mh.1414eb33.svg";